<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Übung</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="saveEducationBody()"
        [disabled]="!this.educationBodyForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="educationBodyForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
  <ion-list class="mt-5 mb-5">
    <ion-item>
      <ion-textarea
        #input
        class="textarea"
        autoGrow
        placeholder="Übung"
        formControlName="body"
        placeholder="z.B. Vorbereitung im Stand"
      ></ion-textarea>
    </ion-item>
    <ion-item lines="full">
      <ion-input
        placeholder="Link zu deinem Übungsmaterial"
        formControlName="hyperlink"
      >
      <ion-icon slot="end" name="link" aria-hidden="true"></ion-icon>
    </ion-input>
    </ion-item>
  </ion-list>
  </form>
</ion-content>
